<div id="assigned-list" *ngIf="occurrence">
    <div class="sheetslist-title"><span translate>sheet-assign.assigned.title</span></div>

    <div class="sheetlist-wrapper">
        <div class="sheetlist-row" *ngFor="let task of taskSheetToDo">
            <div class="sheetlist-subwrap">
                <div class="sheet-icon"
                    [ngClass]="{'sheet-validated': task.what.is_validate_by_student==true, 'sheet-todo': task.what.is_todo_by_student==true}">
                </div>
                <span class="sheet-title"
                    [innerHTML]="exerciceSheetService.getContentValueByTypeContent('title', task.what.content)"></span>
                <button class="seesheet-btn seesheet-btn-desktop"
                    (click)="emitViewEmitter(task.what, 'desktop')"></button>
                <button class="seesheet-btn seesheet-btn-mobile"
                    (click)="emitViewEmitter(task.what, 'mobile')"></button>
            </div>
            <button class="deletesheet-btn" (click)="deleteTask(task)"></button>
        </div>
    </div>
</div>
<div id="available-list">
    <div class="sheetslist-title"><span translate>sheet-assign.available.sheets</span> </div>
    <div>
        <div class="assign-filter-wrap" [formGroup]="filterSearchGroup">
            <input class="assign-filter-field" type="text" id='search' formControlName="title" placeholder="{{'sheet-assign.filter.input.placeholder' | translate}}">
            <button class="assign-filter-btn" (click)="showFilterMenu = !showFilterMenu"><span
                    class="filter-icon"></span><span translate>common.filter</span></button>
        </div>


    </div>
    <div class="filter-and-list-wrap">
        <div class="filter-options-wrapper" *ngIf="showFilterMenu" [formGroup]="filterFormGroup">
            <div class="filter-options">
                <div class="filter-header"><span class="filter-icon"></span><span
                        translate>sheet-assign.available.filter.learning</span>
                    <div class="close-btn" (click)="showFilterMenu=false"></div>
                </div>
                <div class="filter-criteria">
                    <div>
                        <mat-radio-group formControlName="cecrl_level">
                            <div class="filter-title"><span translate>common.level</span> :</div>
                            <mat-radio-button [value]="cecrlLevelAllValue"><span
                                    translate>common.all</span></mat-radio-button>
                            <div class="opt-btn-wrap level-options">
                                <mat-radio-button *ngFor="let level of cecrlLevelList" [value]="level.value">{{
                                    level.label }}</mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="filter-criteria">
                    <div>
                        <mat-radio-group formControlName="category">
                            <div class="filter-title"><span translate>sheet-assign.filter.categories</span> :</div>
                            <mat-radio-button value=""><span translate>common.all</span></mat-radio-button>
                            <div class="opt-btn-wrap">
                                <mat-radio-button *ngFor="let category of categoryList" value="{{ category.id}}"
                                    translate>
                                    <span translate>
                                        {{ category.traduction_key }}
                                    </span>
                                </mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="filter-criteria">
                    <div>
                        <mat-radio-group formControlName="status">
                            <div class="filter-title"><span translate>sheet-assign.filter.status</span> :</div>
                            <mat-radio-button value=""><span translate>common.all</span></mat-radio-button><br>
                            <div class="opt-btn-wrap">
                                <!-- <mat-radio-button value="todo"><span translate>sheet-assign.filter.todo</span></mat-radio-button> -->
                                <mat-radio-button value="completed"><span
                                        translate>sheet-assign.filter.completed</span></mat-radio-button>
                                <mat-radio-button value="uncompleted"><span
                                        translate>sheet-assign.filter.uncompleted</span></mat-radio-button>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
                <div class="filter-criteria" *ngIf="occurrence && isDataSpecificContentReadyObservable.value">
                    <div *ngIf="groupList.length>0">
                        <mat-radio-group formControlName="specific_content">
                            <div class="filter-title"><span translate>sheet-assign.filter.specific_content</span> :
                            </div>
                            <mat-radio-button value=""><span translate>common.all</span></mat-radio-button><br>
                            <mat-radio-button *ngFor="let group of limitedGroupList" value="{{ group.id }}"> {{
                                group.name}}</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <div class="filter-criteria" *ngIf="!occurrence && isDataSpecificContentReadyObservable.value">
                    <div *ngIf="groupList.length>0">
                        <div class="filter-title"><span translate>sheet-assign.filter.specific_content</span> :</div>
                        <mat-select class="speccontent-select" formControlName="limited_specific_content">
                            <mat-option value=""><span translate>common.all</span></mat-option>
                            <mat-option *ngFor="let group of groupList" [value]="group.id">
                                {{ group.name}}
                            </mat-option>
                        </mat-select>

                    </div>
                </div>

                <div class="show-filtered-btn" (click)="newSearch();showFilterMenu=false;" [disabled]="loadSheets"><span
                        translate>sheet-assign.filter.see_filtered_list</span> ({{ countTotalSheets }}) <mat-spinner
                        class="loader" *ngIf="loadSheets"></mat-spinner></div>
                <div class="reset-filters-btn" (click)="resetFilters()"><span
                        translate>sheet-assign.filter.reset_filters</span></div>
            </div>
        </div>
        <div class="sheetlist-wrapper">

            <table mat-table [dataSource]="sheetList" class="sheet-table">

                <!-- Title Column (Icon + Title) -->
                <ng-container matColumnDef="title">
                    <th mat-header-cell *matHeaderCellDef> <span translate>sheet-assign.table.title</span> </th>
                    <td mat-cell *matCellDef="let sheet">
                        <div class="title-column">
                            <div class="sheet-icon"
                                [ngClass]="{'sheet-validated': sheet.is_validate_by_student, 'sheet-todo': sheet.is_todo_by_student}">
                            </div>
                            <span [innerHTML]="getContentValue('title', sheet)"></span>
                        </div>
                    </td>
                </ng-container>

                <!-- Level Column -->
                <ng-container matColumnDef="level">
                    <th mat-header-cell *matHeaderCellDef> <span translate>sheet-assign.table.level</span> </th>
                    <td mat-cell *matCellDef="let sheet" class="nowrap-cell">
                        {{ exerciceSheetService.cecrlLevelToLabel(sheet.cecrl[0].code, true) || 'N/A' }}
                    </td>
                </ng-container>

                <!-- Category Column -->
                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef> <span translate>sheet-assign.table.category</span> </th>
                    <td mat-cell *matCellDef="let sheet" class="nowrap-cell">
                        {{ sheet.category?.name || 'N/A' }}
                    </td>
                </ng-container>


                <!-- Assign Button Column -->
                <ng-container matColumnDef="assign" *ngIf="occurrence">
                    <th mat-header-cell *matHeaderCellDef> <span translate>sheet-assign.table.assign</span> </th>
                    <td mat-cell *matCellDef="let sheet">
                        <button mat-icon-button (click)="assignSheetToClass(sheet);">
                            <mat-icon>add</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> -->
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="emitViewEmitter(row, 'mobile')"
                    class="clickable-row"></tr>
            </table>


            <div *ngIf="nextPage>1"><a (click)="getAvailableSheet()" class="showmore-btn"
                    translate>sheet-assign.loadMore</a></div>
        </div>
    </div>
</div>